<template>
  <div>
    <div class="ts-flex ts-justify-between ts-items-center">
      <h1 class="ts-uppercase ts-font-robot ts-text-lg ts-text-gray-600">
        {{ $t('task.createSubTask') }}
      </h1>
      <button
        @click.prevent="onClickAdd"
        class="ts-h-8 ts-w-8 ts-flex ts-items-center ts-justify-center ts-text-white ts-font-semibold ts-font-robot ts-rounded-full focus:ts-outline-none"
        style="background: rgba(1, 99, 151, 0.7); box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 10px, rgb(0, 0, 0) 0px 0px 0px;"
      >
        <Icon type="ios-add" size="20" />
      </button>
    </div>

    <div class="ts-p-2">
      <table class="ts-w-full">
        <tbody>
          <tr
            class="row-hover ts-relative ts-transition-all ts-duration-300 ts-cursor-pointer"
            v-for="(s, index) in model.sub_tasks"
            :key="index"
            @dblclick.prevent="onSetDataToModal(s, index)"
          >
            <td
              class="ts-w-64 ts-py-2 ts-px-3 ts-whitespace-no-wrap ts-overflow-hidden"
            >
              <div>
                <b class="ts-font-robot ts-text-sm ts-mr-2">{{ s.title }}</b>
                <Icon type="ios-link" v-if="s.file" />
              </div>
            </td>
            <td>
              <b class="ts-font-mono">{{
                displayOwnerName(s.response_by_id)
              }}</b>
              <span class=" ts-ml-2 ts-font-hanuman ts-text-gray-600">{{
                s.remark
              }}</span>
            </td>
            <div
              class="action-icon ts-absolute ts-right-0 ts-mt-1 ts-top-0 ts-flex ts-space-x-2 ts-bg-white ts-px-4"
            >
              <div
                class=" ts-h-8 ts-w-8 ts-rounded-full hover:ts-bg-gray-300 ts-flex ts-items-center ts-justify-center"
              >
                <a
                  href="#"
                  @click.prevent="rowSubTask(index)"
                  class="ts-text-red-600"
                  ><Icon type="ios-trash" size="20"
                /></a>
              </div>
            </div>
          </tr>
        </tbody>
      </table>
    </div>
    <iModalWrapper
      v-model="show_modal"
      :width="400"
      :title="$t('task.taskAction')"
    >
      <div class="ts-space-y-2">
        <div>
          <label class=" ts-mb-0 required ts-font-robot">{{
            $t('task.title')
          }}</label>
          <div class="ts-space-y-2">
            <input v-model="row.title" type="text" class="form-control" />
            <div class="validate" v-if="errors.has('title')">
              {{ errors.first('title') }}
            </div>
          </div>
        </div>
        <div>
          <label class=" ts-mb-0 ts-font-robot required">{{
            $t('task.status')
          }}</label>
          <div class="ts-space-y-2">
            <Select v-model="row.status_id" style="width:100%">
              <Option
                v-for="(item, index) in status"
                :value="item.status_id"
                :key="index"
                >{{ item.project_status }}</Option
              >
            </Select>
            <div class="validate" v-if="errors.has('status_id')">
              {{ errors.first('status_id') }}
            </div>
          </div>
        </div>
        <div>
          <label class=" ts-mb-0 ts-font-robot">{{ $t('task.owner') }}</label>
          <div class="ts-space-y-2">
            <Select
              :filterable="true"
              v-model="row.response_by_id"
              style="width:100%"
            >
              <Option
                v-for="(item, index) in owners"
                :value="item.user_id"
                :key="index"
                >{{
                  item.employee_name_kh + ' ' + item.employee_name_en
                }}</Option
              >
            </Select>
            <div class="validate" v-if="errors.has('response_by_id')">
              {{ errors.first('response_by_id') }}
            </div>
          </div>
        </div>
        <div>
          <label class=" ts-mb-0 ts-font-robot">{{
            $t('task.estimated')
          }}</label>
          <div class="ts-space-y-2">
            <DatePicker
              style="width: 100%"
              :value="row.estimate_date"
              type="daterange"
              format="dd-MM-yyyy"
              @on-change="value => (row.estimate_date = value)"
            />
            <div class="validate" v-if="errors.has('estimate_date')">
              {{ errors.first('estimate_date') }}
            </div>
          </div>
        </div>
        <div>
          <label class=" ts-mb-0 ts-font-robot">{{ $t('task.actual') }}</label>
          <div class="ts-space-y-2">
            <DatePicker
              style="width: 100%"
              :value="row.actual_date"
              type="daterange"
              format="dd-MM-yyyy"
              @on-change="value => (row.actual_date = value)"
            />
            <div class="validate" v-if="errors.has('actual_date')">
              {{ errors.first('actual_date') }}
            </div>
          </div>
        </div>
        <div>
          <label class=" ts-mb-0 ts-font-robot">{{ $t('task.remark') }}</label>
          <div class="ts-space-y-2">
            <textarea
              v-model="row.remark"
              class="form-control"
              rows="3"
            ></textarea>
          </div>
        </div>
        <div
          class="ts-mt-4 ts-border-2 ts-border-dashed ts ts-py-3 ts-px-5 ts-h-24 ts-rounded-md ts-flex ts-items-center ts-space-x-1 ts-justify-center ts-overflow-y-scroll"
          :class="{ 'ts-border-blue-500': isDragOver }"
          @drop="handleOnDrop"
          @dragover.prevent="dragover"
          @dragleave.prevent="dragleave"
          @click.prevent="openFileBrowser"
        >
          <h2
            class="ts-text-gray-300 ts-font-robot ts-text-lg"
            v-if="!row.file"
          >
            <Icon type="md-folder" size="20" /> Drop file here ...
          </h2>
          <div v-else>
            <div v-if="isImage()">
              <img
                :src="readImagePreview()"
                alt="Preview"
                class="ts-w-16 ts-h-16 ts-object-cover ts-object-center"
              />
            </div>
            <div
              v-else-if="isPdf()"
              class="ts-flex ts-items-center ts-justify-center ts-w-full ts-h-full"
            >
              <i class="fas fa-file-pdf fa-3x"></i>
            </div>
            <div
              v-else-if="isExcel()"
              class="ts-flex ts-items-center ts-justify-center ts-w-full ts-h-full"
            >
              <i class="fas fa-file-excel fa-3x"></i>
            </div>
            <div
              v-else
              class="ts-flex ts-items-center ts-justify-center ts-w-full ts-h-full"
            >
              <i class="fas fa-file fa-3x"></i>
            </div>
          </div>
        </div>
        <div class="ts-flex ts-justify-end">
          <button
            @click.prevent="addRowToModal"
            class="ts-px-6 ts-py-2 ts-flex ts-items-center ts-justify-center ts-text-white ts-font-semibold ts-font-robot ts-rounded-lg  focus:ts-outline-none"
            style="background: rgba(1, 99, 151, 0.7);"
          >
            {{ $t('add') }}
          </button>
        </div>
      </div>
      <Spin size="large" fix v-if="loading"></Spin>
    </iModalWrapper>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import iModalWrapper from '../../components/i-modal-wrapper.vue'
import { Errors } from 'form-backend-validation'
export default {
  props: ['value', 'validate'],
  components: {
    iModalWrapper
  },
  data() {
    return {
      status: [],
      owners: [],
      show_modal: false,
      loading: false,
      isDragOver: false,
      errors: new Errors(),
      model: {},
      row: {
        index: undefined,
        title: '',
        status_id: 1,
        response_by_id: '',
        estimate_date: [],
        actual_date: [],
        remark: '',
        file: undefined
      }
    }
  },
  computed: {
    displayOwnerName: vm => id => {
      const findName = vm.owners.find(u => u.user_id == id)
      if (findName) {
        return findName.employee_name_en
      }

      return ''
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    ...mapActions('projectMgt/taskProfile', ['formViewModel']),
    onClickAdd() {
      this.show_modal = true
      this.fetchModel()
    },
    fetchModel() {
      this.loading = true
      this.formViewModel({
        fnName: 'owner,status',
        project_id: this.$route.query.project_id
      })
        .then(response => {
          this.status = response.data.status
          this.owners = response.data.owner
        })
        .finally(() => (this.loading = false))
    },
    handleOnDrop(event) {
      event.preventDefault()
      const selectedFiles = event.dataTransfer.files[0]
      this.processFiles(selectedFiles)
      this.isDragOver = false
    },
    dragover() {
      this.isDragOver = true
    },
    dragleave() {
      this.isDragOver = false
    },
    openFileBrowser() {
      // this.$refs.fileInput.click()
    },
    handleFileSelection(event) {
      const selectedFile = event.target.files[0]
      this.processFiles(selectedFile)
    },
    processFiles(file) {
      this.row.file = file
    },
    isImage() {
      return this.row.file.type.includes('image')
    },
    isPdf() {
      return this.row.file.type === 'application/pdf'
    },
    isExcel() {
      return (
        this.row.file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      )
    },
    readImagePreview() {
      return URL.createObjectURL(this.row.file)
    },
    addRowToModal() {
      let validate = {}

      if (this.row.title == '' || this.row.title == undefined) {
        validate = Object.assign({}, validate, {
          title: ['The title is requried.']
        })
      }

      if (this.row.status_id == '' || this.row.status_id == undefined) {
        validate = Object.assign({}, validate, {
          status_id: ['The status is requried.']
        })
      }

      this.errors = new Errors(validate)

      if (this.errors.any()) {
        this.$toasted.error('Data given invalide.')

        return
      }

      if (this.row.index != undefined) {
        this.model.sub_tasks[this.row.index] = Object.assign(
          {},
          this.model.sub_tasks[this.row.index],
          this.row
        )
      } else {
        this.model.sub_tasks.push(Object.assign({}, this.row))
      }
      this.clearInput()
      this.errors.clear()
    },
    rowSubTask(index) {
      this.model.sub_tasks.splice(index, 1)
    },
    clearInput() {
      this.row.index = undefined
      this.row.title = ''
      this.row.status_id = 1
      this.row.response_by_id = ''
      this.row.estimate_date = []
      this.row.actual_date = []
      this.row.remark = ''
      this.row.file = undefined
    },
    onSetDataToModal(data, index) {
      this.row.index = index
      this.row.title = data.title
      this.row.status_id = data.status_id
      this.row.response_by_id = data.response_by_id
      this.row.estimate_date = data.estimate_date
      this.row.actual_date = data.actual_date
      this.row.remark = data.remark
      this.row.file = data.file
      this.show_modal = true
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.action-icon {
  visibility: hidden;
}
.row-hover:hover {
  box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.247);
  border-radius: 5px;
}
.row-hover:hover .action-icon {
  visibility: visible;
}
</style>
